import React, { useEffect } from "react";
import { Modal, Form, Input, Button, Divider, Select, Switch } from "antd";
import { DollarOutlined, SaveOutlined, StarOutlined } from "@ant-design/icons";
import "./addAndUpdateOoraPlan.css"; 

const { Option } = Select;

const OoraPlanEditModal = ({
  visible,
  onClose,
  planData,
  onSave,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible && planData) {
      form.setFieldsValue(planData);
    } else if (visible) {
      form.resetFields();
    }
  }, [visible, planData, form]);

  const handleFinish = (values) => {
    onSave(values);
  };

  const currencies = ["INR", "USD", "EUR", "GBP"];

  return (
    <Modal
      title={
        <div className="oora-plan-edit-modal-header-content">
          <DollarOutlined className="oora-plan-edit-modal-header-icon" style={{ color: "white" }} />
          <span style={{ color: "white", marginLeft: "10px" }}>
            {planData?._id ? "EDIT PLAN" : "ADD PLAN"}
          </span>
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      destroyOnClose
      width={700}
      className="oora-plan-edit-modal-override"
      styles={{
        header: {
          background: "#0D152B",
          borderRadius: "12px 12px 0 0",
          padding: "20px 24px",
          borderBottom: "none",
        },
        body: {
          padding: "24px",
          background: "#fafafa",
        },
      }}
    >
      <div className="oora-plan-edit-modal-form">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleFinish}
        >
          <div className="oora-plan-edit-section">
            <h3 className="oora-plan-edit-section-header">Basic Information</h3>
            <div className="oora-plan-edit-grid">
              <Form.Item
                label="Plan Name"
                name="plan_name"
                rules={[{ required: true, message: "Please input plan name" }]}
              >
                <Input
                  size="large"
                  placeholder="Enter plan name"
                  className="oora-plan-edit-input-override"
                />
              </Form.Item>

              <Form.Item
                label="Amount"
                name="amount"
                rules={[
                  { required: true, message: "Please input amount" },
                ]}
              >
                <Input
                  type="number"
                  size="large"
                  placeholder="Enter amount"
                  className="oora-plan-edit-input-override"
                />
              </Form.Item>
            </div>

            <div className="oora-plan-edit-grid">
              <Form.Item
                label="Currency"
                name="currency"
                rules={[{ required: true, message: "Please select currency" }]}
              >
                <Select
                  size="large"
                  placeholder="Select currency"
                  className="oora-plan-edit-input-override"
                >
                  {currencies.map((currency) => (
                    <Option key={currency} value={currency}>
                      {currency}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Before Discount Amount (Optional)"
                name="before_discount_amount"
              >
                <Input
                  type="number"
                  size="large"
                  placeholder="Enter original price"
                  className="oora-plan-edit-input-override"
                />
              </Form.Item>
            </div>
          </div>

          <Divider className="oora-plan-edit-divider" />

          {/* Plan Features */}
          <div className="oora-plan-edit-section">
            <h3 className="oora-plan-edit-section-header">Plan Features</h3>
            <Form.Item
              label="Description"
              name="description"
            >
              <Input.TextArea
                rows={3}
                placeholder="Enter plan description"
                className="oora-plan-edit-input-override"
              />
            </Form.Item>

            <Form.Item
              label="Features (JSON Array)"
              name="features"
              valuePropName="checked"
            >
              <Input.TextArea
                rows={4}
                placeholder='Enter features as JSON array: ["Feature 1", "Feature 2", "Unlimited Support"]'
                className="oora-plan-edit-input-override"
              />
            </Form.Item>
          </div>

          <Divider className="oora-plan-edit-divider" />

          {/* Status & Position */}
          <div className="oora-plan-edit-section">
            <h3 className="oora-plan-edit-section-header">Status & Display</h3>
            <div className="oora-plan-edit-grid">
              <Form.Item
                label="Status"
                name="status"
                initialValue="active"
              >
                <Select size="large" className="oora-plan-edit-input-override">
                  <Option value="active">Active</Option>
                  <Option value="inactive">Inactive</Option>
                </Select>
              </Form.Item>

              <Form.Item
                label="Position"
                name="position"
              >
                <Input
                  type="number"
                  size="large"
                  placeholder="Enter display position"
                  className="oora-plan-edit-input-override"
                />
              </Form.Item>
            </div>

            <Form.Item
              label="Most Popular"
              name="is_most_popular"
              valuePropName="checked"
            >
              <Switch checkedChildren={<StarOutlined />} unCheckedChildren={<StarOutlined />} />
            </Form.Item>
          </div>

          {/* Action Buttons */}
          <Form.Item style={{ marginBottom: 0 }}>
            <div className="oora-plan-edit-actions">
              <Button
                size="large"
                onClick={onClose}
                className="oora-plan-edit-btn oora-plan-edit-btn-cancel"
              >
                Cancel
              </Button>
              <Button
                htmlType="submit"
                size="large"
                icon={<SaveOutlined />}
                className="oora-plan-edit-btn oora-plan-edit-btn-primary oora-plan-edit-btn-override"
              >
                <span style={{ color: "black" }}>
                  <p  className="update-btn">{planData?._id ? "Update Plan" : "Create Plan"}</p>
                </span>
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default OoraPlanEditModal;
